 import { useState } from 'react';
 import styles from './Credentailspopup.module.css'; // Adjust the path as needed
import { message } from 'antd';


const CredentialsPopup = ({ onSave, onClose }) => {
    const [credentials, setCredentials] = useState({
        username: '',
        employee_id: '',
        password: '',
        confirmPassword: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation(); // Important to prevent event bubbling
        
        if (!credentials.username || !credentials.employee_id || !credentials.password) {
            message.error("All fields are required!");
            return;
        }
        
        if (credentials.password !== credentials.confirmPassword) {
            message.error("Passwords don't match!");
            return;
        }
        
        if (credentials.password.length < 8) {
            message.error("Password must be at least 8 characters!");
            return;
        }
        
        // Call the onSave prop with credentials
        onSave(credentials);
    };

    return (
        <div className={styles.popupOverlay} onClick={onClose}>
            <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
                <h3>Set Login Credentials</h3>
                <form onSubmit={handleSubmit}>
                    {/* Form fields remain the same */}
                    <div className={styles.formGroup}>
                         <label>Username:</label>
                      <input
                            type="text"
                            name="username"
                            value={credentials.username}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className={styles.formGroup}>
                        <label>Employee ID:</label>
                        <input
                            type="text"
                            name="employee_id"
                            value={credentials.employee_id}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className={styles.formGroup}>
                        <label>Password:</label>
                        <input
                            type="password"
                            name="password"
                            value={credentials.password}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className={styles.formGroup}>
                        <label>Confirm Password:</label>
                        <input
                            type="password"
                            name="confirmPassword"
                            value={credentials.confirmPassword}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className={styles.buttonGroup}>
                        <button type="button" onClick={onClose}>Cancel</button>
                        <button type="submit">Save</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CredentialsPopup;